var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, G, Path } from "react-native-svg";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    color: props.fillLine
  }, props), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "spinner_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "0%",
    stopColor: props.fillLine,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "100%",
    stopColor: props.fillLine,
    stopOpacity: 0.93
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "spinner_svg__b"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: "0%",
    stopColor: props.fillLine
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: "100%",
    stopColor: props.fillLine,
    stopOpacity: 0.93
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    strokeWidth: 4.8
  }, /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#spinner_svg__a)",
    d: "M2.4 32a29.6 29.6 0 0 1 59.2 0"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#spinner_svg__b)",
    d: "M61.6 32a29.6 29.6 0 0 1-59.2 0"
  }))));
};
export default SvgSpinner;